import { EventSource } from "@baseline/runtime/events";


export interface Dismissable extends EventSource<Dismissable.Event>
{
    on(event: "dismiss", handler: (sender: Dismissable) => void): this;
    off(event: "dismiss", handler: (sender: Dismissable) => void): this;
    dismiss(): void;
}

export namespace Dismissable
{
    export function isDismissable(controller: any): controller is Dismissable
    {
        return typeof controller.dismiss == "function";
    }

    export type Event = "dismiss";
}
